import React, { useState } from 'react';
import { Button, Tab, Tabs } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import PageLayout from '../../layouts/PageLayout';
import { useBranch } from '../../context/BranchContext';
import AiDetectionHistory from './AiDetectionHistory';
import AiMonitoringAlertsTab from './AiMonitoringAlertsTab';
import AiCambillSettingsModal from './AiCambillSettingsModal';
import AiVisionBenchTab from './AiVisionBenchTab';
import AiQcTab from './AiQcTab';
import AiStaffConfirmTab from './AiStaffConfirmTab';
import { useAuth } from '../../context/AuthProvider';
import './AiMonitoringPage.css';

/**
 * #162225 / #181800 — trang ĐỐI SOÁT CAMERA ↔ BILL (app Quản lý). Hai tab:
 * - "Lịch sử nhận diện" (mặc định): mỗi lượt quét × vùng sếp đã khoanh có khách, kèm ảnh + khung vùng.
 * - "Cảnh báo không order": luồng cảnh báo cũ theo bàn (#162225).
 * Thao tác chung ở đầu trang: sang màn Khoanh vùng camera, Cài đặt nhận diện (ngưỡng % có khách).
 * Tab đang mở nằm trên URL (`?tab=lich-su|canh-bao|so-sanh`) để F5/chia sẻ link giữ đúng tab.
 * Lệnh sếp 18/10/2026 — tab thứ ba "So sánh mô hình" (chỉ ADMIN): tài khoản/mô hình, chạy kiểm lại, log, xếp hạng.
 * Lệnh sếp 26/10/2026 — tab "QC nhận diện" (`?tab=qc`): Haiku duyệt trước khi gửi tin, thống kê đúng/sai kèm ảnh.
 * Lệnh sếp 31/10/2026 — tab "Nhân viên xác nhận" (`?tab=xac-nhan`): thống kê nhân viên xác nhận bàn + hoá đơn.
 */
const TABS = ['lich-su', 'xac-nhan', 'qc', 'canh-bao', 'so-sanh'];

const AiMonitoringAlertsPage = () => {
  const { selectedBranch } = useBranch();
  const { user } = useAuth();
  const isAdmin = user?.role === 'ADMIN';
  const branchId = selectedBranch?.id;
  const [params, setParams] = useSearchParams();
  const wanted = params.get('tab');
  const tab = TABS.includes(wanted) && (wanted !== 'so-sanh' || isAdmin) ? wanted : 'lich-su';
  const [showSettings, setShowSettings] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const selectTab = (key) => {
    const next = new URLSearchParams(params);
    next.set('tab', key);
    setParams(next, { replace: true });
  };

  return (
    <PageLayout>
      <div className="mc-page cambill-page">
        <div className="mc-page-header my-2 d-flex justify-content-between align-items-start flex-wrap gap-2">
          <div className="mc-page-header-title">
            <h1>Đối soát camera ↔ bill</h1>
            <p className="cambill-subtitle">
              Theo dõi khách ở các vùng đã khoanh trên camera và đối chiếu với bill.
            </p>
          </div>
          <div className="cambill-actions">
            <Button
              size="sm"
              variant="outline-secondary"
              href={`/ai-monitoring/region-split${branchId ? `?branch_id=${encodeURIComponent(branchId)}` : ''}`}
            >
              Khoanh vùng camera
            </Button>
            <Button size="sm" variant="outline-primary" onClick={() => setShowSettings(true)} disabled={!branchId}>
              Cài đặt nhận diện
            </Button>
          </div>
        </div>

        <Tabs activeKey={tab} onSelect={selectTab} className="mb-3" mountOnEnter id="cambill-tabs">
          <Tab eventKey="lich-su" title="Lịch sử nhận diện">
            <AiDetectionHistory key={reloadKey} branchId={branchId} />
          </Tab>
          <Tab eventKey="xac-nhan" title="Nhân viên xác nhận">
            <AiStaffConfirmTab key={reloadKey} branchId={branchId} isAdmin={isAdmin} />
          </Tab>
          <Tab eventKey="qc" title="QC nhận diện">
            <AiQcTab key={reloadKey} branchId={branchId} />
          </Tab>
          <Tab eventKey="canh-bao" title="Cảnh báo không order">
            <AiMonitoringAlertsTab branchId={branchId} />
          </Tab>
          {isAdmin && (
            <Tab eventKey="so-sanh" title="So sánh mô hình">
              <AiVisionBenchTab branchId={branchId} />
            </Tab>
          )}
        </Tabs>
      </div>

      <AiCambillSettingsModal
        show={showSettings}
        onHide={() => setShowSettings(false)}
        branchId={branchId}
        branchName={selectedBranch?.name}
        onSaved={() => setReloadKey((k) => k + 1)}
      />
    </PageLayout>
  );
};

export default AiMonitoringAlertsPage;
